import * as actions from "../actions_agent/Type";
const intialState = {
  count_actions: {},
};
const DashboardReducer = (state = intialState, action) => {
  switch (action.type) {
    case actions.COUNT_EVENTS_DASHBOARD:
      return {
        ...state,
        count_actions: action.payload,
      };
    default:
      return { ...state };
  }
};

export default DashboardReducer;
